import { useEffect } from "react";
import { Link } from "react-router-dom";

export function LegacyRedirect({ to }) {
    useEffect(() => {
        window.location.replace(to);
    }, [to]);
    return null;
}

export default function NotFound() {
    return (
        <div className="max-w-3xl mx-auto px-6 py-20 text-center" data-testid="not-found-page">
            <p className="eyebrow">404</p>
            <h1 className="text-3xl sm:text-4xl font-semibold mt-2">Page not found</h1>
            <p className="text-[var(--lt-muted)] mt-3">The page you are looking for does not exist.</p>
            <Link to="/" className="text-[var(--lt-terracotta)] mt-6 inline-block" data-testid="not-found-home-link">
                Back to home
            </Link>
        </div>
    );
}
